<template>
  <div id="content-header" class="flex items-center justify-between px-4">
    <div id="search-area" class="flex items-center">
      <feather-icon class="icon" icon="SearchIcon" svgClasses="h-5 w-4" />
      <vs-input
        :color="AISEA_COLOR.GRAY"
        placeholder="ファイル名を検索"
        v-model="searchQuery"
        class="flex py-2 vs-input-no-border vs-input-no-shdow-focus w-full"
      ></vs-input>
    </div>

    <switch-button :items="switchItems" :defaultSelected="selectedStatus" />
  </div>
</template>

<script>
import SwitchButton from "@/components/buttons/SwitchButton"
import { ColorMixin, DocumentMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
import { TASK_MANAGER_STATUS } from "@/config/const";

const { mapState, mapActions, mapMutations } = createNamespacedHelpers("enterpriseBackgroundTaskManager");


export default {
  name: "TaskManagerSearchBar",
  mixins: [ColorMixin, DocumentMixin],
  components: { SwitchButton },
  data () {
    return {
      switchItems: [
        {
          key: TASK_MANAGER_STATUS.ALL,
          text: "すべて",
          selectedMethod: this.filterAll
        },
        {
          key: TASK_MANAGER_STATUS.PROGRESS,
          text: "進行中",
          selectedMethod: this.filterProgress
        },
        {
          key: TASK_MANAGER_STATUS.COMPLETED,
          text: "完了",
          selectedMethod: this.filterCompleted
        },
      ],
    }
  },
  computed: {
    ...mapState(["filterName", "selectedFilterStatus"]),
    searchQuery: {
      get() {
        return this.filterName;
      },
      set(val){
        this.SET_FILTER_NAME(val);
      }
    },
    selectedStatus: {
      get() {
        return this.selectedFilterStatus;
      },
      set(val){
        this.SET_FILTER_STATUS(val);
      }
    }
  },
  watch: {
    async searchQuery() {
      //ページ数を0にリセットしてから検索実行
      await this.fetchAllTaskList();
    },
    selectedFilterStatus(val){
      this.selectedStatus = val;
    }

  },
  methods: {
    ...mapActions(["fetchAllTaskList", "searchTask"]),
    ...mapMutations(["SET_FILTER_STATUS", "SET_FILTER_NAME", "SET_CURRENT_TASK_PAGE"]),

    filterAll () {
      this.SET_CURRENT_TASK_PAGE(1);
      this.SET_FILTER_STATUS(null);
      this.fetchAllTaskList();
    },
    filterProgress () {
      this.SET_CURRENT_TASK_PAGE(1);
      this.SET_FILTER_STATUS(TASK_MANAGER_STATUS.PROGRESS)
      this.fetchAllTaskList();
    },
    filterCompleted () {
      this.SET_CURRENT_TASK_PAGE(1);
      this.SET_FILTER_STATUS(TASK_MANAGER_STATUS.COMPLETED)
      this.fetchAllTaskList();
    }
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#search-area {
  .icon {
    color: $aisea-mouse-gray;
  }
}

.right-item {
  .icon {
    color: $aisea-gray;
  }
  .icon:hover {
    border-radius: 5px;
    background: $aisea-white;
  }

  .icon-disabled {
    color: $aisea-mouse-gray;
  }
}
</style>